import { render, staticRenderFns } from "./PlayerDetails.vue?vue&type=template&id=13798e4e"
import script from "./PlayerDetails.vue?vue&type=script&lang=js"
export * from "./PlayerDetails.vue?vue&type=script&lang=js"
import style0 from "./PlayerDetails.vue?vue&type=style&index=0&id=13798e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardActions,QBtn,QCardSection,QTable,QInnerLoading,QTh,QSpinner});
